module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kacc3"))).then(() => parcelRequire('hEqeo'));